import { render, staticRenderFns } from "./TicketsCategory.vue?vue&type=template&id=069f48ee&scoped=true&"
import script from "./TicketsCategory.vue?vue&type=script&lang=js&"
export * from "./TicketsCategory.vue?vue&type=script&lang=js&"
import style0 from "./TicketsCategory.vue?vue&type=style&index=0&id=069f48ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069f48ee",
  null
  
)

export default component.exports